export const API_PROPERTIES_MAPPING = {
  esignature: {
    allowAnyoneToChoosePrintFlow: 'integration.esignature.allowAnyoneToChoosePrintFlow',
    defaultToPrintFlow: 'integration.esignature.defaultToPrintFlow',
  },
  commUnity: {
    partnersAllowed: 'integration.commUnity.partnersAllowed',
  },
  sendgrid: {
    enabled: 'integration.sendgrid.enabled',
  },
  rewrites: {
    enabled: 'integration.rewrites.enabled',
  },
};
